import { Input, Modal } from 'antd';
import React, { Dispatch, memo, SetStateAction, useEffect, useMemo, useState } from 'react';
import * as cts from '../../../constants/ui/svg';
import beside from '../../../assets/images/beside.png';
import slide from '../../../assets/images/slide.png';
import { useTranslation } from 'react-i18next';
import imgPreview1 from '../../../assets/images/imgPreview1.png';
import imgPreview2 from '../../../assets/images/imgPreview2.png';
import { rgbToHex } from 'helpers/functionHelper';
import ModalTextEditor from './ModalTextEditor';
import { NoteStyleConfig } from 'models';
type OrderByRankingItem = {
  id: number;
  layout_ranking: number;
  name: string;
  shop_id: number;
  status: number;
  value: number;
  created_at: string;
  updated_at: string;
};
type SelectedItem = {
  created_at: string;
  description: string | null;
  id: number;
  link: string;
  order_by: number;
  shop_id: number;
  title: string | null;
  type: number;
  updated_at: string;
};
type SliderItem = {
  order_by_image_slider_ranking_id: number;
  order_by_images_slider_ranking: SliderItem;
  created_at: string;
  id: number;
  images_slider: null | SelectedItem;
  images_slider_id: null | number;
  order_by: number;
  order_by_ranking: null | OrderByRankingItem;
  order_by_ranking_id: null | number;
  second_change: number | string;
  layout_ranking: null | number;
  shop_id: number;
  type: number;
  updated_at: string;
  layout_quantity_user_slider_ranking: number;
  quantity_user_slider_app_rank: number | string;
  // Note data for Beside layout (0)
  note_beside?: string | null;
  font_beside?: string | null;
  font_size_beside?: number | null;
  color_beside?: string | null;
  stroke_color_beside?: string | null;
  stroke_width_beside?: number | null;
  // Note data for Slider layout (1)
  note_slider?: string | null;
  font_slider?: string | null;
  font_size_slider?: number | null;
  color_slider?: string | null;
  stroke_color_slider?: string | null;
  stroke_width_slider?: number | null;
};
export type RankingChildItem = {
  id: number;
  shop_id: number;
  program_rank_id: number;
  name: string;
  type: number;
  layout_ranking: number;
  quantity_user_app_rank: number;
  layout_quantity_user_ranking: number;
  order_by: number;
  order_by_ranking_id: number;
  order_by_ranking: OrderByRankingItem;

  color_beside: string;
  color_slider: string;

  font_beside: string;
  font_slider: string;

  font_size_beside: number;
  font_size_slider: number;

  stroke_color_beside: string;
  stroke_color_slider: string | number; // API trả về 0

  stroke_width_beside: number;
  stroke_width_slider: number;

  note_beside: string;
  note_slider: string;

  images_slider: string | null;
  images_slider_id: number | null;

  permissions_staff_creator: any[];

  second_change: number;
  date: string | null;

  created_at: string;
  updated_at: string;

  creator_id: number;
};

interface IModalChangeLayoutRankingItemProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setImageSliderState: React.Dispatch<React.SetStateAction<any>>;
  imageSliderState: SliderItem[];
  selectedItemRanking: RankingChildItem;
  selectItem: any;
}
// type RankingDisplay = 'onlyTop10' | 'otherThan10';
type RankingDisplay = null | 0 | 1; //0 & null: onlyTop10, 1: otherThan10
const ModalChangeLayoutRankingItem: React.FC<IModalChangeLayoutRankingItemProps> = ({
  open,
  setOpen,
  imageSliderState,
  setImageSliderState,
  selectedItemRanking,
  selectItem,
}) => {
  // this component always compare between item.id in tempSelectedItemsTab and itemRanking.id
  // while same component ModalSelectItemProgram compare between item.order_by_ranking_id in tempSelectedItemsTab and itemRanking?.id

  // define
  const { t } = useTranslation();

  // states
  const [tempSelectedItemsTab, setTempSelectedItemsTab] = useState<SliderItem[]>([]);
  const [itemRanking, setItemRanking] = useState<RankingChildItem | null>(null);
  const [isOpenModalEditText, setIsOpenModalEditText] = useState(false);
  const [imagePreview, setImagePreview] = useState<string | null>(null);

  // maybe its profit or nomination
  const currentItemRankingType = useMemo(
    () => tempSelectedItemsTab.find((item) => item.id === itemRanking?.id),
    [tempSelectedItemsTab, itemRanking]
  );

  // functions
  const handleCheckSelectedLayout = (layout: 0 | 1) => {
    return Boolean(
      tempSelectedItemsTab.find((x: any) => x?.id === itemRanking?.id)?.layout_ranking == layout
    );
  };

  const handleChangeLayout = (layout: 0 | 1) => {
    setTempSelectedItemsTab((prev: Array<SliderItem>) => {
      const index = prev.findIndex((x) => x.id === itemRanking?.id);
      if (index === -1) return prev;

      const newArr = [...prev];
      newArr[index] = { ...newArr[index], layout_ranking: layout };

      return newArr;
    });
  };

  // type RankingDisplay = 'onlyTop10' | 'otherThan10';
  // 0 & null: onlyTop10, 1: otherThan10
  // layout_ranking: 0 & 1
  // 0: layout slide 10 person/slide
  // 1: layout carousel 1 person/slide
  const __renderDisplayRankingType = () => {
    const checkRankingDisplay = (type: RankingDisplay) => {
      const normalizedType = type ?? 0;
      const normalizedCurrent = currentItemRankingType?.layout_quantity_user_slider_ranking ?? 0;

      return normalizedCurrent === normalizedType
        ? 'border border-solid border-primary text-primary bg-brand_50 font-notosans-700'
        : 'bg-gray_100 font-notosans-400';
    };

    const updateRankingItem = (updater: (item: SliderItem) => SliderItem) => {
      setTempSelectedItemsTab((prev) => {
        const index = prev.findIndex((x) => x?.id === itemRanking?.id);
        if (index === -1) return prev;

        const next = [...prev];
        next[index] = updater(next[index]);
        return next;
      });
    };
    const handleSelectRankingDisplay = (type: RankingDisplay) => {
      // auto set layout_ranking to 1 to default when switching between ranking display type
      handleChangeLayout(1);

      // update layout_quantity_user_slider_ranking
      const layoutValue = type ? 1 : 0;
      updateRankingItem((item) => ({
        ...item,
        layout_quantity_user_slider_ranking: layoutValue,
      }));
    };

    const handleChangeQuantity = (value: number) => {
      updateRankingItem((item) => ({
        ...item,
        quantity_user_slider_app_rank: value || '',
      }));
    };
    return (
      <>
        {/* Select layout type (from 1 to 10, over 10 person) */}
        <div className="py-4 mx-4 border-b border-border-gray">
          <span className="font-notosans-700">{t('RANKING_DISPLAY')}</span>
          <div className="flex gap-3 mt-2 w-full">
            <button
              onClick={() => handleSelectRankingDisplay(0)}
              className={`w-1/2 rounded-lg transition-all py-[10px] ${checkRankingDisplay(0)}`}
            >
              {t('SHOW_ONLY_TOP_10')}
            </button>
            <button
              onClick={() => handleSelectRankingDisplay(1)}
              className={`w-1/2 rounded-lg transition-all py-[10px] ${checkRankingDisplay(1)}`}
            >
              {t('DISPLAY_OTHER_THAN_10')}
            </button>
            {currentItemRankingType?.layout_quantity_user_slider_ranking === 1 && (
              <Input
                suffix={'人'}
                onChange={(e) => handleChangeQuantity(Number(e.target.value))}
                value={currentItemRankingType.quantity_user_slider_app_rank}
                className="w-20  px-2 text-center border border-solid rounded-lg !outline-none border-border-gray"
                placeholder="人数"
                type="number"
              />
            )}
          </div>
        </div>
      </>
    );
  };

  const __renderSelectedRankItemLayoutCheck = (checked: 0 | 1, text: 'BESIDE' | 'SLIDER') => {
    return (
      <div className="flex items-center">
        <span>{handleCheckSelectedLayout(checked) ? cts.checkActive : cts.check}</span>
        <span className="text-sm text-[#252B37] notosans_normal ml-2">{t(text)}</span>
      </div>
    );
  };

  const _renderClassStyleRankItemCheck = (layout: 0 | 1) => {
    return `${
      handleCheckSelectedLayout(layout)
        ? 'bg-[#F9F5FF] border border-solid border-primary'
        : 'border border-solid border-border-gray'
    } relative flex flex-col items-center justify-center rounded-lg p-3 w-1/2`;
  };

  const _renderClassStyleRankItemEditFontButton = (layout: 0 | 1) => {
    return `absolute right-2 top-0 mt-2 bg-white size-10 rounded-lg border border-solid border-primary flex items-center justify-center ${
      handleCheckSelectedLayout(layout)
        ? 'cursor-pointer'
        : 'opacity-90 cursor-not-allowed pointer-events-none'
    }`;
  };

  // useEffects
  useEffect(() => {
    if (open) {
      setTempSelectedItemsTab(imageSliderState);
      setItemRanking(selectedItemRanking);
    }
  }, [open]);

  return (
    <Modal
      centered
      open={open}
      onOk={() => setOpen(false)}
      onCancel={() => setOpen(false)}
      className="override-antd-modal-border-radius"
      bodyStyle={{
        padding: 0,
      }}
      footer={null}
      title={null}
      closeIcon={<></>}
      width={644}
    >
      <div className="flex flex-col">
        <div className="flex justify-between items-center px-4 h-14 border-b border-solid border-border-gray">
          <span className="text-[#1D2939] text-xl font-notosans-700">{t('LAYOUT')}</span>
          <button onClick={() => setOpen(false)} className="text-base notosans_medium text-primary">
            {t('CLOSE')}
          </button>
        </div>
        {__renderDisplayRankingType()}
        <div className="flex gap-3 items-center p-4 border-b border-border-gray">
          {/* layout slide */}
          <button
            onClick={() => handleChangeLayout(1)}
            className={_renderClassStyleRankItemCheck(1)}
          >
            <span
              onClick={(e) => {
                e.stopPropagation();
                handleChangeLayout(1);
                setIsOpenModalEditText(true);
                setImagePreview(imgPreview2);
              }}
              className={_renderClassStyleRankItemEditFontButton(1)}
            >
              {cts.editBtn}
            </span>
            <img src={slide} className="w-full" />
            {__renderSelectedRankItemLayoutCheck(1, 'SLIDER')}
          </button>

          {/* layout grid view */}

          <button
            disabled={currentItemRankingType?.layout_quantity_user_slider_ranking == 1}
            onClick={() => handleChangeLayout(0)}
            className={`${_renderClassStyleRankItemCheck(0)} ${currentItemRankingType?.layout_quantity_user_slider_ranking == 1 && 'cursor-not-allowed opacity-60 !bg-[#f5f5f5]'}`}
          >
            <span
              onClick={(e) => {
                e.stopPropagation();
                handleChangeLayout(0);
                setIsOpenModalEditText(true);
                setImagePreview(imgPreview1);
              }}
              className={`${_renderClassStyleRankItemEditFontButton(0)} ${currentItemRankingType?.layout_quantity_user_slider_ranking == 1 && '!bg-[#f5f5f5]'}`}
            >
              {cts.editBtn}
            </span>

            <img src={beside} className="w-full" />
            {__renderSelectedRankItemLayoutCheck(0, 'BESIDE')}
          </button>
        </div>
        <div className="p-4">
          <button
            onClick={() => {
              setImageSliderState((prev: any) => {
                // Lấy order_by cao nhất hiện tại
                const maxOrder = prev.reduce(
                  (max: any, item: any) => Math.max(max, item.order_by),
                  0
                );
                // Tạo danh sách mới từ tempSelectedItemsTab (giữ nguyên các field note)
                const addedItems: any = tempSelectedItemsTab.map((item, index) => {
                  // Lấy name từ order_by_ranking nếu note null (dịch sang tiếng Nhật)

                  const defaultNote = item.order_by_ranking
                    ? t(item.order_by_ranking.name)
                    : item.order_by_image_slider_ranking_id &&
                        item.order_by_images_slider_ranking?.order_by_ranking
                      ? t(item.order_by_images_slider_ranking.order_by_ranking.name)
                      : null;

                  return {
                    ...item,
                    created_at: item.created_at,
                    updated_at: item.updated_at,
                    images_slider_id: item.images_slider_id,
                    images_slider: item.images_slider,
                    order_by: maxOrder + index + 1,
                    // order_by_ranking: item.order_by_image_slider_ranking_id
                    //   ? item.order_by_images_slider_ranking.order_by_ranking
                    //   : item.order_by_ranking,
                    // order_by_ranking_id: item.order_by_image_slider_ranking_id
                    //   ? item.order_by_images_slider_ranking.order_by_ranking_id
                    //   : item.order_by_ranking_id,
                    second_change: item.second_change || 30,
                    // Default là 0 (Beside) nếu null
                    program_rank_id: selectItem?.id,
                    shop_id: item.shop_id,
                    type: item.type,

                    // Giữ nguyên các field note đã lưu, nếu không có thì lấy name từ order_by_ranking
                    note_beside: item.note_beside ?? defaultNote,
                    font_beside: item.font_beside ?? 'NotoSansNormal',
                    font_size_beside: item.font_size_beside ?? 20,
                    color_beside: item.color_beside ?? '#FEC84B',
                    stroke_color_beside: item.stroke_color_beside ?? '#ffffff',
                    stroke_width_beside: item.stroke_width_beside ?? 2,
                    note_slider: item.note_slider ?? defaultNote,
                    font_slider: item.font_slider ?? 'NotoSansNormal',
                    font_size_slider: item.font_size_slider ?? 20,
                    color_slider: item.color_slider ?? '#FEC84B',
                    stroke_color_slider: item.stroke_color_slider ?? '#ffffff',
                    stroke_width_slider: item.stroke_width_slider ?? 2,
                  };
                });

                return [...addedItems];
              });
              setOpen(false);
            }}
            className="w-full h-11 text-base text-center text-white rounded-lg font-notosans-700 bg-primary"
          >
            {t('KEEP')}
          </button>
        </div>
      </div>
      {isOpenModalEditText && itemRanking && (
        <ModalTextEditor
          onClose={() => {
            setIsOpenModalEditText(false);
          }}
          initialNote={(() => {
            const currentItem = tempSelectedItemsTab.find(
              (x: any) => x?.order_by_ranking_id === itemRanking?.order_by_ranking_id
            );

            if (!currentItem) return t(itemRanking?.name ?? '');
            // Nếu currentLayoutForEdit null, dùng layout_ranking của item, default là 0
            const layoutForEdit = currentItem.layout_ranking ?? 0;

            // Lấy note theo layout (0 = beside, 1 = slider)
            const note = layoutForEdit === 0 ? currentItem.note_beside : currentItem.note_slider;
            return note || t(itemRanking?.name ?? '');
          })()}
          initialStyleConfig={(() => {
            const currentItem = tempSelectedItemsTab.find(
              (x: any) => x?.order_by_ranking_id === itemRanking?.order_by_ranking_id
            );
            if (!currentItem) return undefined;

            // Nếu currentLayoutForEdit null, dùng layout_ranking của item, default là 0
            const layoutForEdit = currentItem.layout_ranking ?? 0;

            // Lấy styleConfig theo layout (0 = beside, 1 = slider)
            if (layoutForEdit === 0) {
              return currentItem.font_beside
                ? {
                    font: currentItem.font_beside,
                    font_size: currentItem.font_size_beside || 20,
                    color: currentItem.color_beside || '#FEC84B',
                    stroke_color: currentItem.stroke_color_beside || '#ffffff',
                    stroke_width: currentItem.stroke_width_beside || 2,
                  }
                : undefined;
            } else {
              return currentItem.font_slider
                ? {
                    font: currentItem.font_slider,
                    font_size: currentItem.font_size_slider || 20,
                    color: currentItem.color_slider || '#FEC84B',
                    stroke_color: currentItem.stroke_color_slider || '#ffffff',
                    stroke_width: currentItem.stroke_width_slider || 2,
                  }
                : undefined;
            }
          })()}
          onSave={(data: { note: string; styleConfig: NoteStyleConfig }) => {
            // Lưu note vào local state (tempSelectedItemsTab) - lưu từng field riêng biệt
            setTempSelectedItemsTab((prev: SliderItem[]) => {
              const index = prev.findIndex(
                (x) => x?.order_by_ranking_id === itemRanking?.order_by_ranking_id
              );
              if (index === -1) return prev;

              const newArr = [...prev];
              const currentItem = newArr[index];

              // Nếu layout_ranking null, set default là 0 (Beside)
              const layoutRanking = currentItem.layout_ranking ?? 0;
              const layoutForEdit = layoutRanking;

              // Lưu note theo layout (0 = beside, 1 = slider)
              if (layoutForEdit === 0) {
                newArr[index] = {
                  ...newArr[index],

                  layout_ranking: 0, // Đảm bảo layout_ranking có giá trị
                  note_beside: data.note,
                  font_beside: data.styleConfig.font,
                  font_size_beside: data.styleConfig.font_size,
                  color_beside: rgbToHex(data.styleConfig.color),
                  stroke_color_beside: data.styleConfig.stroke_color,
                  stroke_width_beside: data.styleConfig.stroke_width,
                };
              } else {
                newArr[index] = {
                  ...newArr[index],
                  layout_ranking: 1, // Đảm bảo layout_ranking có giá trị
                  note_slider: data.note,
                  font_slider: data.styleConfig.font,
                  font_size_slider: data.styleConfig.font_size,
                  color_slider: rgbToHex(data.styleConfig.color),
                  stroke_color_slider: data.styleConfig.stroke_color,
                  stroke_width_slider: data.styleConfig.stroke_width,
                };
              }

              return newArr;
            });
            setIsOpenModalEditText(false);
          }}
          previewImage={imagePreview as string}
          isNote={false}
        />
      )}
    </Modal>
  );
};

export default memo(ModalChangeLayoutRankingItem);
